import debugFactory from 'debug';
import { getUserInfo } from '../rest/securityAccessRest';
import { userInfoStart, startAuthentication, userInfoSuccess } from '../security/authDucks';
import { loadDocuments } from '../../documents/documentsDucks';
import { loadNews } from '../../news/newsDucks';
import containerInjector from '../components/containerInjector';
import { loadRoadmap } from '../../roadmap/roadmapDucks';
import { loadLinks } from '../../links/linksDucks';

const debug = debugFactory('initDucks');

// Constants
export const INIT_START = 'INIT_START';
export const INIT_SUCCESS_ONLINE = 'INIT_SUCCESS_ONLINE';
export const INIT_SUCCESS_OFFLINE = 'INIT_SUCCESS_OFFLINE';
export const APP_OFFLINE = 'APP_OFFLINE';
export const APP_ONLINE = 'APP_ONLINE';

// ACTIONS
export const initSuccessOnline = store => (
  (dispatch) => {
    dispatch({
      type: INIT_SUCCESS_ONLINE,
      payload: { offline: false },
    });
    dispatch(loadDocuments());
    dispatch(loadNews());
    dispatch(loadRoadmap());
    dispatch(loadLinks());

    containerInjector(store);
  }
);

export const initSuccessOffline = store => (
  (dispatch) => {
    dispatch({
      type: INIT_SUCCESS_OFFLINE,
      payload: { offline: true },
    });

    containerInjector(store);
  }
);

/**
 * Registers an event listener that triggers an attempt to load user
 * details on window focus.
 *
 * This is done to refresh data stored browser side each time the window
 * is active again.
 */
const initUserLoadOnWindowFocus = (dispatch) => {
  window.addEventListener('focus', () => {
    debug('Refresh user infos');
    dispatch(userInfoStart());
  });
};

export const initStart = store => (
  (dispatch, getState) => {
    dispatch({
      type: INIT_START,
    });

    // Offline first
    if (getState().securityContext.authenticated) {
      dispatch(initSuccessOffline(store));
    }

    // is user really authenticated ? request to server side to verify...
    getUserInfo().then((response) => {
      if (response.ok) {
        initUserLoadOnWindowFocus(dispatch);

        /*
         * The user is authenticated.
         *
         * An HTTP request is triggered to load user information.
         *
         * On top of that, an vent listener is added to the window object to
         * load user details on the window focus.
         */
        debug('Auth verifier OK');
        response.json().then((json) => {
          dispatch(userInfoSuccess(json));
          dispatch(initSuccessOnline(store));
        });
      } else {
        /*
         * The user is not authenticated.
         * The logout procedure should be started.
         */
        debug('Auth verifier KO');
        startAuthentication();
      }
    },
    () => {
      debug('Auth verifier Offline');
      /*
       * the user is offline. We cannot check whether or not
       * it is authenticated server-side.
       */
      initUserLoadOnWindowFocus(dispatch); // FIXME Check if this is required
      dispatch(initSuccessOffline(store));
    });
  }
);



// WEBPACK FOOTER //
// ./book/src/commons/initializers/initDucks.js